import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface CreateProjectRequestPayload {
  name: string
  owner: string
  address: {
    city: string
    state: string
  }
  regions: {
    name: string
  }[]
}

export interface CreateProjectResponse {
  id: number
  regions: { id: number; name: string }[]
}

export async function createProject(payload: CreateProjectRequestPayload) {
  const { data } = await companiesApi.post<CreateProjectResponse>(
    apiRoutes.createProject,
    {
      project: payload,
      users: [],
    },
  )

  return data
}
